import { convertMapToClassname } from "../../../utils/classStyles";
import galleryImage from "../../../images/galleryImage.png";

import IconPreview from "./IconPreview";
import { BASE_URL } from "../../../constant/constant";
import MaterialIcon from "../MaterialIcon";

export const ButtonPreview = ({ config }) => {
  return (
    <button
      className={`${
        Object.keys(config.className || {}).length > 0 ? "" : "drop_button"
      } fields_align ${convertMapToClassname(config.className || {})}`}
    >
      {config.icon && <IconPreview icon={config.icon || ""} />}
      {config.name || "button"}
    </button>
  );
};
export const PositionedButtonPreview = ({ config }) => {
  return (
    <button
    // className={className}
    // style={{
    //   height: style.height,
    //   width: style.width,
    //   minWidth: "initial",
    //   maxWidth: "initial",
    //   marginLeft: "initial"
    // }}
    >
      {config.icon && <IconPreview icon={config.icon || ""} />}
      {config.name || "button"}
    </button>
  );
};

export const DropdownPreview = ({ config }) => {
  return (
    <button
      className={`${
        Object.keys(config.className || {}).length > 0 ? "" : "drop_button"
      } fields_align ${convertMapToClassname(config.className || {})}`}
    >
      {config.icon && <IconPreview icon={config.icon || ""} />}
      {config.name}
      <MaterialIcon name="keyboard_arrow_down" />
    </button>
  );
};

export const ButtonGroupPreview = ({ config }) => {
  return (
    <div className="flex_wrap gap_2">
      {config.button_list.length > 0 ? (
        config.button_list.map((button) => <ButtonPreview key={button.id} config={button} />)
      ) : (
        <div>Button Group</div>
      )}
    </div>
  );
};

export const ImagePreview = ({ config = {} }) => {
  const ImagePreviewStyles = {
    height: config?.style?.height ? config.style.height : "60px",
    width: config?.style?.width ? config.style.width : "60px"
  };
  const modifiedRepoSource = config?.repo_source ? `${BASE_URL}/api/v1/public/${config?.repo_source}` : "";
  const imageSource = modifiedRepoSource || config.source || galleryImage;

  return (
    <img
      style={ImagePreviewStyles}
      className={` ${convertMapToClassname(config.className || {})}`}
      src={imageSource}
      alt="img"
    />
  );
};

export const LabelPreview = ({ config, labelOnClick = () => {} }) => {
  return (
    <div className={`fields_align ${convertMapToClassname(config.className || {})}`} style={config.inline_style}>
      {config.icon && <IconPreview icon={config.icon} />}
      <label onClick={labelOnClick}>{config.name || ""}</label>
    </div>
  );
};

export const RecordsetListPreview = ({ config }) => {
  const numberOfColumns = Number(config.cards_per_row) || 1;
  const numberOfRows = 2;

  const renderItems = () => {
    return [...Array(numberOfRows)].map((_, rowIndex) => (
      <div key={rowIndex} className="recordset_list_row">
        {[...Array(numberOfColumns)].map((_, colIndex) => (
          <div key={colIndex} className="recordset_list_item">
            Record {colIndex + 1}
          </div>
        ))}
      </div>
    ));
  };

  return <div>{renderItems()}</div>;
};

export const TableFieldInfoPreview = ({ config }) => {
  return (
    <div className={`fields_align ${convertMapToClassname(config.className)}`} style={config.inline_style}>
      {config.icon && <IconPreview icon={config.icon || ""} />}
      <>{tableFieldInfo(config)}</>
    </div>
  );
};

export const tableFieldInfo = (config) => {
  const prefix = config.prefix ? config.prefix + "." : "";
  const nameOrDisplay = config.display || config.name || "";
  return `${prefix}${nameOrDisplay}`;
};

export const TableFieldPlaceholderPreview = ({ config }) => {
  let placeholder = "";
  placeholder = config.placeholder || "";
  if (!placeholder) {
    placeholder = tableFieldInfo(config);
  }
  return (
    <div
      className={`fields_align ${convertMapToClassname(config.className)}`}
      style={config.inline_style}
      title={tableFieldInfo(config) + ` [${config.field_type}]`}
    >
      {config.icon && <IconPreview icon={config.icon || ""} />}
      {placeholder}
    </div>
  );
};
